/*
 * Script to handle user scroll in both way: down and top
 */

function handleScrolling() {
  const navbar = document.querySelector('.navbar');
  const toTopBtn = document.querySelector('#to-top');

  window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
      navbar.classList.add('navbar-sticky');
      toTopBtn.classList.add('show');
    } else {
      navbar.classList.remove('navbar-sticky');
      toTopBtn.classList.remove('show');
    }
  });
}

function scrollToTop() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}

// Event Listeners
document.addEventListener('turbo:load', handleScrolling);
document.addEventListener('turbo:load', function () {
  document.querySelector('#to-top').addEventListener('click', scrollToTop);
});
